// The URL prefix the client is served under: Vite's `base`, set from BASE_PATH at build time so the
// game can live at a reverse-proxy subpath (e.g. https://example.com/shoveoff/). '/' by default.
// Optional chaining: Node (tsx) has no import.meta.env when the soak imports client modules.
export const BASE_URL: string = import.meta.env?.BASE_URL ?? '/';

/** `pathname` relative to the base, keeping the leading slash: '/shoveoff/r/ABCD' → '/r/ABCD'. */
export function stripBase(pathname: string, base: string = BASE_URL): string {
  if (base === '/') return pathname;
  if (pathname.startsWith(base)) return pathname.slice(base.length - 1);
  return pathname === base.slice(0, -1) ? '/' : pathname;
}
